module.exports = __webpack_public_path__ + "static/media/CV_Farah_DRIDI_Software_Engineer.91e3198f.pdf";